module.exports = __webpack_public_path__ + "static/img_senior-thougthful-adae4d82a408dd13b2183c3671dc4642.png";